import Vue from 'vue';

import { buildFetchMutations } from '@/store/extensions/fetch';
import { buildCreateMutations } from '@/store/extensions/create';
import { buildDeleteMutations } from '@/store/extensions/delete';

export default {
  ...buildFetchMutations(['fetchPtoAvailabilities', 'deletePtoAvailabilities']),
  ...buildCreateMutations(['createPtoAvailability']),
  ...buildDeleteMutations(['deletePtoAvailability']),

  updatePtoAvailabilityPending: (state) => {
    Vue.set(state, 'updating', true);
  },

  updatePtoAvailabilitySuccess: (state) => {
    Vue.set(state, 'updating', false);
  },

  updatePtoAvailabilityError: (state) => {
    Vue.set(state, 'updating', false);
  },

  openFormModal: (state, payload = null) => {
    Vue.set(state, 'formModalOpened', true);
    Vue.set(state, 'formModalContext', payload);
  },

  closeFormModal: (state) => {
    Vue.set(state, 'formModalOpened', false);
    Vue.set(state, 'formModalContext', null);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/ptoAvailability/mutations.js